import ComponentWithSocket from '../../../lib/component'
import { Component, Watch } from 'vue-property-decorator';

import * as Store from '../../../store';

import template from './list.vue';
import moment from 'moment';

import WebsocketClient, { WebsocketsListener } from '../../../utils/ws';

@Component({
    mixins: [template]
})

export default class UsersList extends ComponentWithSocket {

    private data: {
        users: any[],
        qrUserOpen: boolean,
        qrUserId: string,
        pushUserOpen: boolean,
        pushUserId: string,
        pushUserSubject: string,
        pushUserContent: string,
        pushUserData: string,
        perPage: number,
        currentPage: number,
        usersCount: number,
        searchQuery: string,
        isSearching: boolean
    } = {
        users: [],
        qrUserOpen: false,
        qrUserId: '',
        pushUserOpen: false,
        pushUserId: '',
        pushUserSubject: '',
        pushUserContent: '',
        pushUserData: '',
        perPage: 50,
        currentPage: 1,
        usersCount: 0,
        searchQuery: this.$attrs.s ? this.$attrs.s : "",
        isSearching: false
    };

    rejectReason: string = ''
    selectedVerification?: any

    @Watch('data.searchQuery')
    onSearchQueryChanged(val: string, oldVal: string) {
        if (!this.data.isSearching) {
            setTimeout(() => {
                this.data.isSearching = false;
                this.data.currentPage = 1;
                this.insertParam('s', this.data.searchQuery);
                
                this.reloadUsers(1);
            }, 1000);
        }
        this.data.isSearching = true;
    }

    constructor() {

        super();

        this.wsListener.onGet('admin.users', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (success) {
                this.data.users = data.users;
                this.data.usersCount = data.usersCount;
            }

        });

        this.wsListener.onPost('admin.users.push', (success: boolean, data: any) => {

            if (!success) {
                return alert(data)
            }

            this.data.pushUserId = ''
            this.data.pushUserSubject = ''
            this.data.pushUserContent = ''
            this.data.pushUserData = ''
            this.data.pushUserOpen = false

        });

    }

    public reloadUsers(
        page: any = this.data.currentPage
    ) {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet("admin.users", {
            searchQuery: this.data.searchQuery,
            perPage: this.data.perPage,
            currentPage: page 
        });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('admin.users', {
            searchQuery: this.data.searchQuery,
            perPage: this.data.perPage,
            currentPage: this.data.currentPage 
        });

    }

    qrUserOpen(user: any) {
        this.data.qrUserOpen = true
        this.data.qrUserId = user._id
    }

    openPushNotification(user: any) {
        this.data.pushUserId = user._id
        this.data.pushUserOpen = true
    }

    sendPushNotification() {
        this.wsListener.sendPost('admin.users.push', {
            userId: this.data.pushUserId,
            title: this.data.pushUserSubject,
            content: this.data.pushUserContent,
            data: this.data.pushUserData
        });
    }

    public insertParam(key: any, value: any) {
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);
    
        // kvp looks like ['key1=value1', 'key2=value2', ...]
        var kvp = document.location.search.substr(1).split('&');
        let i=0;
    
        for(; i<kvp.length; i++){
            if (kvp[i].startsWith(key + '=')) {
                let pair = kvp[i].split('=');
                pair[1] = value;
                kvp[i] = pair.join('=');
                break;
            }
        }
    
        if(i >= kvp.length){
            kvp[kvp.length] = [key,value].join('=');
        }
    
        // can return this or...
        let params = kvp.join('&');
    
        // reload page with new params
        window.history.replaceState(null, '', '?' + params);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/users/list/index.ts